import * as React from "react";
import {
  ButtonsSection,
  FGCustomPanel,
  FGTextInput,
  FieldGroup,
  FieldSet,
  showError,
  showSuccess,
} from "nsitools-react";
import * as Yup from "yup";
import { ETLCodes } from "../../locales";
import { SmallFormGenerator } from "../../components";
import { Card, Classes } from "@blueprintjs/core";
import { useApiService, useTl } from "../../hooks";
import { EPlatform, UsersApi } from "../../api";
import { useHistory } from "react-router";
import { ELoginRoutes } from "../../LoginRouter";
import styled from "styled-components";
import assets from "../../assets";
import { isBrcs } from "../../drupal/DrupalApp";

export interface IForgottenPasswordProps {}
const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 100px;
  & .${Classes.FORM_CONTENT} {
    width: 100%;
  }
`;

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const ForgottenPassword: React.FunctionComponent<IForgottenPasswordProps> = (props) => {
  const api = useApiService(UsersApi);
  const history = useHistory();
  const [reseting, setreseting] = React.useState(false);
  const { t } = useTl();
  const resetPassword = React.useCallback(
    async (values: any) => {
      setreseting(true);
      try {
        const res = await api.resetPassword(values.email, EPlatform.CARE4DOGS, isBrcs);
        if (res !== null && res.value) {
          showSuccess(t(ETLCodes.NewPasswordEmailSent));
          history.push(ELoginRoutes.login);
        } else {
          showError(t(ETLCodes.UnknownEmail));
        }
        setreseting(false);
        return res;
      } catch {
        setreseting(false);
        showError(t(ETLCodes.Error));
      }
    },
    [api, history, t]
  );
  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      email: Yup.string().nullable().email(t(ETLCodes.InvalidEmail)).required(t(ETLCodes.Required)),
    });
  }, [t]);
  return (
    <Container>
      <ColumnContainer>
        <img src={assets.images.srshLogo} alt="SRSH_LOGO" style={{ height: "200px" }} />
        <h1>Care 4 Dogs</h1>
        <Card elevation={4}>
          <FieldSet collapsable={false} title={t(ETLCodes.ForgottenPasswordTitle)}>
            <SmallFormGenerator
              initialValues={{ email: "" }}
              labelAlignment="center"
              onSubmit={resetPassword}
              minLabelWidth={300}
              editMode={true}
              boldLabel={true}
              inline={false}
              validationSchema={FormSchema}
              hideButtons={true}
              showColons={false}
              autoRequiredMark={false}
              centerForm={true}
              enableDirtyCheck={false}
            >
              <FieldGroup columns={1}>
                <FGTextInput name="email" label={t(ETLCodes.Email)} />
              </FieldGroup>
              <FGCustomPanel>
                {({ formik }) => (
                  <ButtonsSection
                    buttons={[
                      {
                        position: "center",
                        text: t(ETLCodes.ResetPassword),
                        intent: "primary",
                        icon: "refresh",
                        type: "submit",
                        large: true,
                        loading: reseting,
                        disabled: !(formik.touched && formik.isValid),
                      },
                    ]}
                  />
                )}
              </FGCustomPanel>
            </SmallFormGenerator>
          </FieldSet>
        </Card>
      </ColumnContainer>
    </Container>
  );
};
